import { AppContext } from "../Context/AppContext";
import { useState, useEffect, useLayoutEffect } from "react";
import { useWebSocket } from "../useWebSocket";
import { getKeyValue } from "../CommonComponents/CommonWorkers";

export function AppState(props) {
	const [theme, setTheme] = useState({
		color: "dark",
		fontMultiplier: "1.25",
		headerFontMultiplier: "1.25",
		bodyLeftFontMultiplier: "1.25",
		bodyCenterFontMultiplier: "1.25",
		bodyRightFontMultiplier: "1.25",
		footerFontMultiplier: "1.25",
	});
	const connection = useWebSocket(setTheme);
	const scaleFactor = useCurrentScaleFactor(window.devicePixelRatio);
	useEffect(() => {
		const initConfig = async () => {
			const res = await getKeyValue("color");
			const headerFontRes = await getKeyValue("headerFontMultiplier");
			const bodyLeftFontMultiplierRes = await getKeyValue(
				"bodyLeftFontMultiplier"
			);
			const bodyCenterFontMultiplierRes = await getKeyValue(
				"bodyCenterFontMultiplier"
			);
			const bodyRightFontMultiplierRes = await getKeyValue(
				"bodyRightFontMultiplier"
			);
			const footerFontMultiplierRes = await getKeyValue("footerFontMultiplier");
			const color = res[0]?.RES;
			const headerFontMultiplier =
				window.screen.width > 600 ? headerFontRes[0]?.RES : 3;
			const bodyLeftFontMultiplier =
				window.screen.width > 600 ? bodyLeftFontMultiplierRes[0]?.RES : 3;
			const bodyCenterFontMultiplier =
				window.screen.width > 600 ? bodyCenterFontMultiplierRes[0]?.RES : 3;
			const bodyRightFontMultiplier =
				window.screen.width > 600 ? bodyRightFontMultiplierRes[0]?.RES : 3;
			const footerFontMultiplier =
				window.screen.width > 600 ? footerFontMultiplierRes[0]?.RES : 3;
			setTheme((prev) => ({
				...prev,
				color: color,
				headerFontMultiplier: headerFontMultiplier,
				bodyLeftFontMultiplier: bodyLeftFontMultiplier,
				bodyCenterFontMultiplier: bodyCenterFontMultiplier,
				bodyRightFontMultiplier: bodyRightFontMultiplier,
				footerFontMultiplier: footerFontMultiplier,
			}));
		};
		initConfig();
	}, []);
	return (
		<AppContext.Provider
			value={{
				theme: { ...theme, scaleFactor },
				connection,
				setTheme,
			}}
		>
			{props.children}
		</AppContext.Provider>
	);
}

const useCurrentScaleFactor = (initValue) => {
	const [scaleFactor, setScaleFactor] = useState(initValue);
	useEffect(() => {
		const updateScaleFactor = () => {
			setScaleFactor(window.devicePixelRatio);
		};
		window.addEventListener("resize", updateScaleFactor);
		return () => {
			window.removeEventListener("resize", updateScaleFactor);
		};
	}, []);
	return scaleFactor;
};
